const mergeWithDefault = <T extends {}>(values: T, defaultValues: T): T =>
    Object.keys(values).reduce((result, key) => ({ ...result, [key]: values[key] ?? defaultValues[key] }), {} as T);

export default mergeWithDefault;
